export const SITE_LIST = 'site_list';
export const PREFILLED_GATE_DATA = 'prefilled_gate_data';
export const SAVE_RENEWAL_REQUEST = 'save_renewal_request';
export const PREFILLED_REQUEST='prefilled_request';
export const REQUEST_LIST='request_list';
export const UPDATE_REQUEST_STATUS = 'update_request_status';
export const REQUEST_DETAILS = 'request_details';
export const FILTERS='FILTERS';
export const PREVIOUS_REQUESTS='PREVIOUS_REQUESTS';
export const BASE_PRICES='BASE_PRICES';
export const UPDATE_CLIENT_STATUS='UPDATE_CLIENT_STATUS';
export const CLIENT_STATUS_OPTIONS='CLIENT_STATUS_OPTIONS';
